module.exports = __webpack_public_path__ + "img/jiuyinqiche.aea741c5.png";